import { extract } from "./../ricos-content/lib/extract";
class GetContentExtractorError extends Error {
}
class RicosContentQueryService {
  setEditor(editor, converters) {
    this.editor = editor;
    this.converters = converters;
  }
  getContentExtractor() {
    if (!this.editor) {
      throw new GetContentExtractorError(
        "getContentExtractor called without initialize editor instance (setEditor)"
      );
    }
    const tiptapContent = this.editor.getJSON();
    const richContent = this.converters.fromPm(tiptapContent);
    const nodes = richContent.nodes;
    return extract(nodes ?? []);
  }
}
export {
  RicosContentQueryService
};
//# sourceMappingURL=ContentQueryService.js.map
